import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { QuotationRoutingModule } from './quotation-routing.module';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { GetQuoteComponent } from './get-quote/get-quote.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { QuotationPremiumComponent } from './quotation-premium/quotation-premium.component';
import { ProposalFormComponent } from './proposal-form/proposal-form.component';
import { MyQuotationComponent } from './my-quotation/my-quotation.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CompareProductComponent } from './compare-product/compare-product.component';
import { MatRadioModule } from '@angular/material/radio';
import { CustomCurrencyPipe } from 'src/app/core/pipes/custom-currency.pipe';
import { ProposalFormV1Component } from './proposal-form-v1/proposal-form-v1.component';
import { MatStepperModule } from '@angular/material/stepper';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from 'src/app/app.module';
import { HttpClient } from '@angular/common/http';
import { MatTooltipModule } from '@angular/material/tooltip';
@NgModule({
  declarations: [
    GetQuoteComponent,
    QuotationPremiumComponent,
    ProposalFormComponent,
    MyQuotationComponent,
    CompareProductComponent,
    CustomCurrencyPipe,
    ProposalFormV1Component,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    QuotationRoutingModule,
    SharedModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    NgxPaginationModule,
    MatDatepickerModule,
    MatChipsModule,
    MatCheckboxModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTableModule,
    MatDialogModule,
    MatRadioModule,
    MatStepperModule,
    MatTooltipModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader, // exported factory function needed for AoT compilation
        deps: [HttpClient],
      },
    }),
  ],
})
export class QuotationModule {}
